import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=fbbd15ce&scoped=true&"
import script from "./pagination.vue?vue&type=script&lang=js&"
export * from "./pagination.vue?vue&type=script&lang=js&"
import style0 from "./pagination.vue?vue&type=style&index=0&id=fbbd15ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbd15ce",
  null
  
)

export default component.exports